import { styled } from '@mui/material/styles'
import { Accordion, AccordionSummary, AccordionDetails, Box, Stack, Typography, IconButton, Divider } from '@mui/material'

export const COMMON_WIDTH = '30px'

export const StyledStack = styled(Stack)({
  paddingLeft: 0,
  paddingRight: 0,
  maxHeight: '300px',
  overflowY: 'scroll',
  paddingTop: '15px',
  paddingBottom: '15px'
})

export const StyledAccordion = styled(Accordion)({
  paddingLeft: 0,
  paddingRight: 0,
  transition: 'background-color 160ms ease',
  '&::before': {
    opacity: 0
  }
})

export const StyledAccordionSummary = styled(AccordionSummary)({
  padding: 0,
  border: 'none',
  minHeight: '35px',
  height: '35px',
  '&.Mui-expanded': {
    minHeight: '35px',
  },
  '& .MuiAccordionSummary-content': {
    margin: '0',
    '&.Mui-expanded': {
      margin: '0',
    }
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    position: 'relative',
    left: 0,
    order: -1,
    transition: 'transform 160ms ease',
  },
  display: 'flex',
  alignItems: 'center',
})

export const StyledTitle = styled(Typography)({
  fontSize: '12px',
  fontWeight: 500,
  paddingLeft: '15px',
  color: '#464646',
  flex: '1 1 auto',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const StyledDivider = styled(Divider)({
  flex: 1,
  display: 'none'
})

export const StyledCounter = styled(Box)({
  backgroundColor: '#F7F7F7',
  borderRadius: '6px',
  padding: '1px 8px',
  color: '#656565',
  whiteSpace: 'nowrap',
  fontSize: '10px',
  lineHeight: '14px',
})

export const StyledIconButton = styled(IconButton)({
  padding: 0,
  color: '#FFFFFF',
  backgroundColor: '#E5E5E5',
  width: '16px',
  height: '16px',
  borderRadius: '50%',
  lineHeight: 1,
  '&:hover': {
    backgroundColor: '#E5E5E5'
  },
  '& i': {
    color: '#FFFFFF'
  }
})

export const StyledAccordionDetails = styled(AccordionDetails)({
  padding: 0,
  paddingLeft: '18px',
  transition: 'height 160ms ease, opacity 160ms ease'
})

export const StyledSubRow = styled(Box)({
  position: 'relative'
})

export const StyledSubRowStack = styled(Stack)({
  flex: 1,
  height: '35px',
  width: COMMON_WIDTH,
  position: 'absolute',
  left: '-25px',
})

export const StyledSubRowContent = styled(Stack)(({ theme }) => ({
  height: '35px',
  minHeight: '35px',
  '&:hover': {
    backgroundColor: theme.palette.background.tertiary,
  },
}))

export const StyledSubRowText = styled(Typography)(({ italic }) => ({
  fontSize: '12px',
  lineHeight: '18px',
  fontWeight: 400,
  color: '#656565',
  paddingLeft: '12px',
  ...(italic && {fontStyle: 'italic'})
}))
